<script>
	import { mapActions } from 'vuex';
	import axios from 'axios';
	import { bankVerification } from '@/app/api';

	axios.defaults.headers.common['Content-Type'] = 'application/json';
	axios.defaults.headers.common['Accept'] = 'application/json';

	export default {
		props: {
			application: {
				type: Object,
				default: null
			},
			goToNextStep: {
				type: Function,
				default: () => {}
			}
		},
		data() {
			return {
			};
		},
		methods: {
			...mapActions([
				'saveLoading',
				'showErrorAlert',
				'showSuccessAlert'
			]),
			async sendBankVerification() {
				this.saveLoading(true);
				try {
					await bankVerification(this.application.application.id);
					this.saveLoading(false);
					this.showSuccessAlert('A request has been sent to Inverite to confirm banking information.')
					return await this.goToNextStep();
				} catch (error) {
					console.error(`Error: ${JSON.stringify(error)}`);
					this.saveLoading(false);
					this.showErrorAlert('Something went wrong, try again.');
				}
			}
		}
	};
</script>

<template>
	<div>
		<!--e-signature-template-->
		<div class="e-signature-template">
			<div class="container-xl">
				<div class="row">
					<div class="col-24">
						<div class="template__page-title">
							<h1>Bank Verification</h1>
						</div>
						<div class="template__page-description">
							<p>
								Send a bank verification to your customer, or skip to the next step
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="mb-5"></div>
			<form @submit.prevent="() => {}" novalidate>
				<div class="container-xl template--vh">
					<div class="row">
						<div class="col-lg-12">
							<div class="tffi-card tffi-card-main-card e-signature-card">
								<div class="row">
									<div class="col-lg-12 d-flex align-items-center">
										<p class="my-0">
											Use Bank Verification
										</p>
									</div>
									<div class="col-lg-12 d-flex align-items-center justify-content-center justify-content-xl-end">
										<button @click="sendBankVerification()" class="tffi-btn tffi-btn--solid theming primary-color mx-auto-lg w-100 fw-bold">
											Send
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-12">
							<div class="tffi-card tffi-card-main-card signed-contract-card">
								<div class="row">
									<div class="col-lg-12 d-flex align-items-center">
										<p class="my-0">
											Skip Bank Verification
										</p>
									</div>
									<div class="col-lg-12 d-flex align-items-center justify-content-center justify-content-xl-end">
										<button @click="() => goToNextStep()" class="tffi-btn tffi-btn--solid theming primary-color mx-auto-lg w-100 fw-bold">
											Skip
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.sign-links {
	list-style: none;
	padding-left: 0px;
}
select {
	display: inline!important;
}
</style>
